<template>
  <div
    class="pointer-events-auto relative flex w-[326px] gap-2.5 overflow-hidden rounded-r2 border-[0.5px] bg-neutral-50 p-spacing_9 shadow-lg"
    :key="id"
    @mouseenter="$emit('pauseTimer')"
    @mouseleave="$emit('resumeTimer')"
  >
    <CommonUIcons
      class="h-8 w-8"
      :name="type === 'error' ? 'ic-info' : 'ic-check'"
      :class="{
        'text-errors': type === 'error',
        'text-success-200': type === 'success',
      }"
      @click="$emit('close', id)"
    />

    <div class="flex grow justify-between">
      <p class="font-secondary text-size_4 font-bold text-neutral-800">
        {{ message }}
      </p>
      <CommonUIcons
        class="h-8 w-8 cursor-pointer"
        name="ic-x"
        @click="$emit('close', id)"
      />
    </div>

    <div
      class="loader absolute bottom-0 left-0 h-1 transition-all duration-100"
      :class="{
        'bg-errors': type === 'error',
        'bg-success-100': type === 'success',
        'bg-action': type === 'info',
      }"
      :style="{ animationDuration: `${duration}ms` }"
    />
  </div>
</template>

<script setup lang="ts">
import type { ToastProps } from "~/types/schemas/common/Atom/toaster";

defineEmits<{
  close: [id: number];
  pauseTimer: [];
  resumeTimer: [];
}>();

defineProps<ToastProps>();
</script>
